import { useFluentContext } from "@fluentui/react-northstar";
import { useMemo } from "react";

import { ColorSchemes } from "./useColorScheme.types";

export function useFluentColorScheme() {
  const {
    theme: {
      siteVariables: { colorScheme },
    },
  } = useFluentContext();

  return useMemo(() => {
    const { default: main, ...otherSchemes } = colorScheme as ColorSchemes;
    return { main, ...otherSchemes };
  }, [colorScheme]);
}
